import React from 'react';
import { Box } from './styles';

export type PaperProps = {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
};

export const Paper = (props: PaperProps) => {
  const { children, className } = props;

  return <Box className={className}>{children}</Box>;
};

export default Paper;
